import React from "react";
import PropTypes from "prop-types";

// Assets
import logo from "assets/images/logo.svg";
import bCorpBlackLogo from "assets/images/b-corp-logo-black.png";
import bCorpWhiteLogo from "assets/images/b-corp-logo-white.png";

// Components
import AccountLockedModal from "components/Modals/AccountLocked/AccountLocked";
import ServerErrorModal from "components/Modals/ServerError/ServerError";
import Portal from "components/Portal/Portal";
import FooterText from "components/FooterText/FooterText";

// Tools
import useWindowSize from "hooks/useWindowSize";

export default function Main(props) {
  const { isDesktop } = useWindowSize();

  return (
    <div className="layout layout-main">
      <Portal>
        <AccountLockedModal />
        <ServerErrorModal />
      </Portal>
      {!isDesktop && <img src={bCorpBlackLogo} className="b-corp-logo" alt="B-Corp logo" />}
      <div className="left-wrapper">
        <div className="container">
          <div className="content">
            <div className="empty-block"></div>
            <div className="b-corp">
              <div className="ta-c">
                <img src={bCorpWhiteLogo} className="b-corp-logo" alt="B-Corp logo" />
              </div>
              <div className="coheadline fs-20 ta-c mt1">
                We're proud to be a certified B Corporation <span className="fs-22">&copy;</span>
              </div>
              <div className="mt2 ta-c">
                Being a B Corp means our social and environmental performance, accountability and
                transparency have been assessed and certified. We strongly believe that there is no
                trade-off between 'doing good' and making money, and our business can pursue purpose
                as well as profit. We care about how we do business.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-wrapper">
        <div className="container">
          <div className="content">
            <div className="main">
              <img src={logo} className="logo" alt="OI logo" />
              {props.children}
            </div>
          </div>
          <FooterText isEnabled={props.showFooterText} />
        </div>
      </div>
    </div>
  );
}

Main.propTypes = {
  showFooterText: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
